import script from "./home.vue?vue&type=script&setup=true&lang=js"
export * from "./home.vue?vue&type=script&setup=true&lang=js"

import "./home.css?vue&type=style&index=0&id=c13b6072&scoped=true&lang=css"

import exportComponent from "D:\\work\\gw-zl\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c13b6072"]])

export default __exports__